import { render, staticRenderFns } from "./StandardResponsesTable.vue?vue&type=template&id=16436ad3&"
import script from "./StandardResponsesTable.vue?vue&type=script&lang=js&"
export * from "./StandardResponsesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports